import React from 'react';
import { func, bool, node } from 'prop-types';
import { Button } from '../../../ui';

export default function FormButtonSubmit({ onPress, disabled, children }) {
  return (
    <Button
      onClick={onPress}
      appearance="primary-neue"
      disabled={disabled}
    >
      {children}
    </Button>
  );
}

FormButtonSubmit.propTypes = {
  onPress: func,
  disabled: bool,
  children: node,
};

FormButtonSubmit.defaultProps = {
  onPress: null,
  disabled: false,
  children: null,
};
